import type { IconData } from '@stacksjs/iconify-core'

export const sizing: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M8.022 34.666c-2.558-.18-4.509-2.13-4.688-4.688C3.16 27.503 3 23.893 3 19s.16-8.503.334-10.978c.18-2.558 2.13-4.509 4.688-4.688C10.497 3.16 14.107 3 19 3s8.503.16 10.978.334c2.558.18 4.509 2.13 4.688 4.688C34.84 10.497 35 14.107 35 19s-.16 8.503-.334 10.978c-.18 2.558-2.13 4.509-4.688 4.688C27.503 34.84 23.893 35 19 35s-8.503-.16-10.978-.334M45 35h-4m4-32h-4m2 0v32M3 45v-4m32 4v-4m0 2H3\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default sizing
